import { type Field } from '@/lib/types';
import { createContext } from 'react';

const FieldContext = createContext<Field>(null as unknown as Field);

export default FieldContext;
